// Bookings.jsx
import React, { useEffect, useState } from "react";
import { getUserBookings, updateBookingStatus } from "../../services/bookingService";
import Invoice from "./invoice";


export default function MyBookings() {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getUserBookings().then(data => {
            setBookings(data);
            setLoading(false);
        }).catch(err => {
            console.error("Failed to fetch bookings:", err);
        });
    }, []);

    const handleCancel = (bookingId) => {
        updateBookingStatus(bookingId, 'canceled').then(() => {
            const updatedBookings = bookings.map(booking => {
                if (booking._id === bookingId) {
                    return { ...booking, status: 'canceled' };
                }
                return booking;
            });
            setBookings(updatedBookings);
            alert("Booking canceled successfully!");
        }).catch(err => {
            console.error("Failed to cancel booking:", err);
        });
    };

    return (
        <section className="trips">
            <header className="trips-header">
                <h1>Bookings</h1>
                {/* <Link to="/admin/bookings/new" className="btn-primary">+ New Booking</Link> */}
            </header>


            <div className="trip-grid">
                {!loading && bookings.length === 0 && <p>No bookings found.</p>}
                {bookings && bookings.map((cat, i) => (
                    <article className="trip-card" key={i}>
                        <div className="trip-card-top">
                            <h3>{cat.trip.title}</h3>

                        </div>
                        <p className="">$ {cat.totalPrice}</p>
                        <p className="">Date: {cat.date}</p>
                        <p>Number of People: {cat.totalPersons}</p>
                        <p className="meta">Status: {cat.status}</p>
                        <div className="flex row gap-10">
                            <Invoice bookingId={cat._id} />
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}